import { AbstractControl, ValidatorFn } from "@angular/forms";

export function inArray(arr: any[], property?: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let inArr;

    if (property) {
      inArr = !!arr.find((item) => {
        return item[property] === control.value;
      });
    } else {
      inArr = !!arr.find((item) => item === control.value);
    }

    return inArr ? null : { valueNotInArray: "Value not an option" };
  };
}
